var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout p-15px"},[(_vm.$route.name !== 'home_wiki')?[_vm._v(" Tổng hợp các hạng mục kiến thức ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }